import { useEffect, Fragment } from "react";
import { Form, Row, Col } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import Icons from "./Icons";


export const HGCFormRow = ({ label, children }) => {
  return <Row style={{ marginBottom: "1.5em" }}>
    <Form.Label column sm={3}>{label}</Form.Label>
    <Col sm={6}>
      {children}
    </Col>
  </Row>;
}

export const FormCellText = ({ dataState, errorState, validate, autoFocus = false }) => {
  const [data, setData] = dataState;
  const [error, setError] = errorState;
  // This needs to be defined twice...
  useEffect(() => { setError(validate(data)); }, [data, setError, validate])
  return <div className="d-flex align-items-center">
    <Form.Control
      text="text"
      value={data === null ? "" : data}
      onChange={(e) => { setData(e.target.value === "" ? null : e.target.value) }}
      isInvalid={!!error}
      autoFocus={autoFocus}
    />
    <Form.Control.Feedback type="invalid">{error}</Form.Control.Feedback>
  </div>

}

export const HGCFormRowText = ({ label, dataState, errorState, validate, autoFocus = false }) => {
  return <HGCFormRow label={label}>
    <FormCellText dataState={dataState} errorState={errorState} validate={validate} autoFocus={autoFocus} />
  </HGCFormRow>
}

export const FormCellDate = ({ dataState }) => {
  const [data, setData] = dataState;
  return <DatePicker
    className='form-control form-control-solid w-250px '
    selected={data}
    dateFormat="yyyy/MM/dd"
    onChange={(date) => { setData(date) }}
  />
}

export const HGCFormRowDate = ({ label, dataState }) => {
  return <HGCFormRow label={label}>
    <FormCellDate dataState={dataState} />
  </HGCFormRow>
}

// Selections error state can be unspecified unless allow Null is set to true
export const FormCellSelect = ({ dataState, errorState, options, allowNull, autoFocus = false }) => {
  const [data, setData] = dataState;
  const [error, setError] = errorState ? errorState : [false, false];

  useEffect(() => {
    if (!allowNull) {
      setError(data === null ? "Cannot be null." : "");
    }
  }, [data, allowNull, setError]);
  const selectOptions = [{ value: "null", label: "(none)" }, ...options]

  return <Row>
    <Col>
      <Select // Do not change back to Form.Select!!
        onChange={async (e) => { setData(e.value === "null" ? null : e.value); }}
        defaultValue={data === null ? selectOptions[0] : selectOptions.find((v) => String(v.value) === String(data))}
        options={selectOptions}
        autoFocus={autoFocus}
        styles={{
          control: (baseStyles) => ({
            ...baseStyles,
            borderColor: (!allowNull && error) ? 'red' : 'gray',
          }),
          option: (baseStyles, { data }) => ({
            ...baseStyles,
            color: (data.available === undefined || data.available) ? "black" : "gray",
            textDecoration: (data.available === undefined || data.available) ? "" : "line-through",
          }
          )
        }}
      />
    </Col>
    <Col>
      <span style={{ color: "red", paddingLeft: "1em" }}>{!allowNull && error}</span>
    </Col>
  </Row>
}

export const HGCFormRowSelect = ({ label, dataState, errorState, options, allowNull = true, autoFocus = false }) => {
  return <HGCFormRow label={label}>
    <FormCellSelect dataState={dataState} errorState={errorState} options={options} allowNull={allowNull} autoFocus={autoFocus} />
  </HGCFormRow>
}

export const FormCellBool = ({ dataState, errorState, allowNull, label }) => {
  const [data, setData] = dataState;
  const [error, setError] = errorState ? errorState : [false, false];

  useEffect(() => {
    if (!allowNull) {
      setError(data === null ? "Cannot be null." : "");
    }
  }, [data, allowNull, setError]);

  return <Fragment>
    <Form.Check label={Icons.ok} type="radio" name={label} checked={data === true} onClick={() => { setData(data === true ? null : true) }} inline readOnly />
    <Form.Check label={Icons.wrong} type="radio" name={label} checked={data === false} onClick={() => { setData(data === false ? null : false) }} inline readOnly />
    <span style={{ color: "red", paddingLeft: "1em" }}>{!allowNull && error}</span>
  </Fragment>
}

export const HGCFormRowBool = ({ label, dataState, errorState, allowNull = true }) => {
  return <HGCFormRow label={label}>
    <FormCellBool dataState={dataState} errorState={errorState} allowNull={allowNull} label={label} />
  </HGCFormRow >
}
